module.exports = __webpack_public_path__ + "img/remove-button.09aba77d.svg";